var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5466 3.98623C19.7088 4.40625 17.9929 4.95214 17.0466 5.07905C18.013 4.42635 19.5682 3.12956 19.9176 1.89668C19.0128 2.50103 18.013 2.94069 16.9449 3.17639C16.0936 2.1505 14.877 1.50989 13.5305 1.50989C10.9486 1.50989 8.85396 3.87442 8.85396 6.79042C8.85396 7.2044 8.89411 7.6063 8.97442 7.99309C6.46392 7.7725 4.44285 5.67237 2.13403 2.47383C1.73115 3.25647 1.50094 4.16451 1.50094 5.13147C1.50094 6.96266 2.32677 8.57931 3.58223 9.52663C2.81664 9.50095 2.09387 9.26072 1.46212 8.86789V8.93285C1.46212 11.4923 3.07495 13.6272 5.21647 14.1106C4.8243 14.2345 4.41072 14.2965 3.98376 14.2965C3.68261 14.2965 3.38815 14.2648 3.10306 14.2028C3.69867 16.2999 5.42526 17.8274 7.47308 17.8682C5.8723 19.2854 3.85393 20.13 1.66289 20.13C1.28545 20.13 0.912026 20.1058 0.546631 20.0575C2.61721 21.5532 4.96561 21.6632 7.59326 21.3952C12.5933 20.8853 18.2258 14.3826 18.2258 7.40384C18.2258 7.17418 18.2338 6.64051 18.2258 6.41539C19.1399 5.67053 19.9216 5.04536 20.5466 3.98623Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fad4cea8.svg";
export { ForwardRef as ReactComponent };